import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import SignupForm from '../SignupForm';
import events from '../SignupPageContainer/events';
import { AdjustTrackEvent } from '../../modules/analytics/adjust';
import { trackEvent } from '../../modules/analytics';
import {
  Wrapper,
  OverlayWrapper,
  Overlay,
  OverlayHeaderSection,
  OverlayContent,
  SwitchToAnchor,
} from '../ImportOnboarding/styles';
import { ValuePropositions } from './components/ValuePropositions';
import { OverlayOverrideCSS, Header1, Paragraph } from '../LoginPage/styles';
import { Header2, SwitchToAnchorOverrideCSS } from './styles';
import { ENABLE_WORDPRESS } from '../../screens/WordpressScreen/constants';
import { WordPressHero } from './components/WordPressHero';

function Hero({ isWordPressReferral }) {
  if (isWordPressReferral) {
    return <WordPressHero />;
  }
  return (
    <SwitchToAnchor className={SwitchToAnchorOverrideCSS}>
      <Header2>Welcome to Anchor</Header2>
      <ValuePropositions />
    </SwitchToAnchor>
  );
}

export function SignupPage({
  error,
  routing,
  onSubmit,
  anyTouched,
  submitting,
  onClickRequestResetPassword,
  location: { search },
}) {
  const { ref } = queryString.parse(search);
  // LAUNCH WORDPRESS
  // ----------------
  // remove ENABLE_WORDPRESS
  const isWordPressReferral = ENABLE_WORDPRESS && ref === 'wp';
  useEffect(() => {
    // Required for Floodlight tagging
    // eslint-disable-next-line no-undef
    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      send_to: 'DC-9266237/ancho0/spoti00+standard',
    });

    // adjust log for viewing sign up
    trackEvent(
      null,
      { eventToken: AdjustTrackEvent.ONBOARDING_STARTED },
      // eslint-disable-next-line no-undef
      { providers: [Adjust] }
    );
  }, []);

  return (
    <Wrapper>
      <Hero isWordPressReferral={isWordPressReferral} />
      <OverlayWrapper>
        <Overlay className={OverlayOverrideCSS}>
          <OverlayHeaderSection>
            <Header1>Create your account</Header1>
            <Paragraph>
              Already have an account?{' '}
              <Link
                data-cy="loginLink"
                to="/login"
                onClick={events.signUpSignInButtonClicked}
              >
                Log in
              </Link>{' '}
              instead.
            </Paragraph>
          </OverlayHeaderSection>
          <OverlayContent>
            <SignupForm
              anyTouched={anyTouched}
              error={error}
              onSubmit={onSubmit}
              routing={routing}
              submitting={submitting}
              location={routing.location}
              onClickRequestResetPassword={onClickRequestResetPassword}
              isWordPressReferral={isWordPressReferral}
            />
          </OverlayContent>
        </Overlay>
      </OverlayWrapper>
    </Wrapper>
  );
}
